import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { changePassword } from '../../Redux/features/auth/authSlice';
import { toast } from 'react-toastify';

const ChangePass = () => {
	const [formData, setFormData] = useState({
		NewPassword: '',
		confirmPassword: '',
	});
	const [error, setError] = useState(null);

	const dispatch = useDispatch();

	// Handle form data change
	const handleChange = (e) => {
		setError(null);
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Check if new password matches the confirmation
		if (formData.NewPassword !== formData.confirmPassword) {
			setError('New passwords do not match.');
			return;
		}

		const NewPassword = formData.NewPassword;

		try {
			dispatch(changePassword({ NewPassword })).then((response) => {
				if (response.payload.data.success === true) {
					toast.success(response?.payload?.data?.message);
					setFormData({
						NewPassword: '',
						confirmPassword: '',
					});
				} else {
					toast.error(response.payload);
				}
			});
		} catch (err) {
			setError(err.response?.data?.message || 'Error changing password.');
		}
	};

	return (
		<div>
			<div className='flex flex-col justify-center items-center md:mt-10 mt-2 py-10'>
				<p className='uppercase mb-8 text-xl font-semibold'>Change Password</p>
				<form
					onSubmit={handleSubmit}
					className='lg:w-[25%] md:w-1/2 w-[90%] bg-white rounded-xl shadow-xl px-6 md:px-10 py-5'>
					<div>
						<label className='text-sm md:text-base'>New Password</label>
						<input
							name='NewPassword'
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='password'
							placeholder='Enter Your New Password'
							value={formData.NewPassword}
							onChange={handleChange}
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Confirm Password</label>
						<input
							name='confirmPassword'
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='password'
							placeholder='Confirm Your New Password'
							value={formData.confirmPassword}
							onChange={handleChange}
							required
						/>
					</div>
					<button className='proBtn w-full h-10 rounded-none mt-3'>Update Password</button>
					{error && <p className='text-red-500 mt-2'>{error}</p>}
				</form>
			</div>
		</div>
	);
};

export default ChangePass;
